import React, { Component } from 'react'
import { Col, Row, Input } from 'reactstrap'
import { debounce } from 'lodash'
import AdvancedFiltersControl from '../../Filters/AdvancedFiltersControl'
import AppliedAdvancedFilters from '../../Filters/AppliedAdvancedFilters'

class PaymentPlanListHeader extends Component {
    updateSearchTerm = debounce((searchTerm) => {
        this.props.setFilterValues({ ...this.props.filterValues, searchTerm })
    }, 500)

    render() {
        return (
            <Row className="pb-3 align-items-center">
                <Col xs={4}>
                    <span className="driver-search-filter">
                        <Input type="text" name="searchTerm" placeholder="Search" onChange={(e) => this.updateSearchTerm(e.target.value)} />
                        <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                    </span>
                </Col>
                <Col xs="auto" className="p-0">
                    <AdvancedFiltersControl entity="payment_plan" presets={this.props.presets} setPresets={this.props.setPresets} defaultPresets={this.props.defaultPresets} />
                </Col>
                <Col />
                <Col xs={12} className="mt-2 search-filter-container">
                    <AppliedAdvancedFilters
                        entity="payment_plan"
                        context={null}
                        presets={this.props.presets}
                        onPresetsChange={this.props.setPresets}
                    />
                    {this.props.selectedPlans && this.props.selectedPlans.length > 0 && <span className="search-filter-preview">
                        <span> <i className="fa fa-times-circle" onClick={this.props.resetselectedPlans}></i> &nbsp;&nbsp; Selected Members</span>
                        {this.props.selectedPlans.length}
                    </span>}
                </Col>
            </Row>
        )
    }
}

export default PaymentPlanListHeader
